import React from 'react';
import BackgroundDecor from './BackgroundDecor';
import DemoHeader from './DemoHeader';
import ProgressSteps from './ProgressSteps';
import { BD } from '../bookDemoTheme';

interface DemoLayoutProps {
  children: React.ReactNode;
  onClose: () => void;
  /** 1-based progress index; omit to hide the progress bar (terminal screens). */
  currentStep?: number;
}

const DemoLayout: React.FC<DemoLayoutProps> = ({ children, onClose, currentStep }) => (
  <div className={`relative min-h-screen overflow-x-hidden font-sans ${BD.pageBg}`}>
    <BackgroundDecor />
    <div className="relative z-[2] flex min-h-screen flex-col">
      <DemoHeader onClose={onClose} />
      {currentStep !== undefined && <ProgressSteps currentStep={currentStep} />}
      <main className="flex flex-1 flex-col w-full max-w-[1440px] mx-auto px-4 sm:px-6">{children}</main>
    </div>
  </div>
);

export default DemoLayout;
